import { render, staticRenderFns } from "./ZeitraumWahl.vue?vue&type=template&id=36d04bf8&"
import script from "./ZeitraumWahl.vue?vue&type=script&lang=js&"
export * from "./ZeitraumWahl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports